import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {baseUrl} from "./constants/appUrls";


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: false,

    // debug: __IS_DEV__,
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {loadPath: `${baseUrl}locales/{{lng}}/{{ns}}.json?v=${__UNIQ_NUMBER__}`},
    // backend: {
    //   loadPath: `${baseUrl}locales/{{lng}}/{{ns}}.json`,
    //
    // },
  });

i18n.changeLanguage("en");


export default i18n;